import React from 'react';
import styled from 'styled-components';
import WordCloudAnalysis from '../../../components/InsightsWordCloud/WordCloudAnalysis';
import GraphHOC from '../../../Common/GraphHOC/GraphHOC';
import { useParsedEndDate, useParsedStartDate } from '../../../utils/ParseDate';
import { emoji_anger, emoji_disgust, emoji_fear, emoji_joy, emoji_neutral, emoji_sadness, emoji_surprise } from '../../../Common/SvgIcon/CommonSvgIcons';
import VerticalBarGraph from '../../../Common/BarGraph/VarticalBargraph';
import BarGraph from '../../../Common/BarGraph/BarGraph';
import RatingDonutChart from '../../../Common/RatingDonutChart/DonutChart';
import DonutChart from '../../../Common/SentimentCharts/SentimentCharts';
import FunnelGraph from '../../../Common/FunnelGraph/FunnelGraph';

const Wrapper = styled.div`
  padding: 30px;
  margin-bottom: 50px;
  & .title {
    color: #636363;
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;
  }
`;

const EmotionAnalysisWrapper = styled.div`
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  padding: 0px 10px;
  align-items: center;
  margin-top: 30px;

  .titleContainer {
    margin: 25px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .correlationGraphContainer {
    padding: 1px 20px 20px 20px;
  }

  & > p:first-child {
    ${'' /* color: #636363; */}
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;

    margin: 20px 0px 0px 10px;
  }
`;
const InsightsTab = ({ 
    insights_data = {},
  startDate = '',
  endDate = '',
  filteredData,
  filterOption,
  filteredStartDate,
  filteredEndDate,
  view,
  resetFlag,
  channel,
  hideDropdown,
  is_news = false,
  formatValue = 'dd-yyyy-MM',
  search_type = '',
  job_id,
  handleTabClick, }) => {
    
  const COLOR_RANGE_1 = [
    '#C4C4CD',
    '#87D3F2',
    '#4EBEEB',
    '#35B8E8',
    '#188CE6',
    '#1777CF',
    '#155CB4',
  ];
      const startDateParsed = useParsedStartDate(
        resetFlag,
        filteredStartDate,
        startDate,
        formatValue
      );
      const endDateParsed = useParsedEndDate(
        resetFlag,
        filteredEndDate,
        endDate,
        formatValue
      );
    if (Object.keys(insights_data).length === 0) {
        return (
            <h2
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '30px',
                }}
            >
                {/* No data available */}Insufficient Data
            </h2>
        );
    }
    
  const options = ['Bar Graph', 'Pie Chart', 'Donut Chart', 'Funnel Chart'];

  const emotionAnalysis = [
    {
      name: 'Neutral',
      value:insights_data?.emotion_analysis[0].neutral,
      fill: '#FDE3A2',
       },
    {
      name: 'Surprise',
      value:insights_data?.emotion_analysis[0].surprise,
      fill: '#4FD786',
      },
    {
      name: 'Joy',
      value: insights_data?.emotion_analysis[0].joy,
      fill: '#E651CE',
      },
    {
      name: 'Fear',
      value:insights_data?.emotion_analysis[0].fear,
      fill: '#FFB84D',
       },
    {
      name: 'Sadness',
      value:insights_data?.emotion_analysis[0].sadness,
      fill: '#5C9BDB',
       },
    {
      name: 'Anger',
      value: insights_data?.emotion_analysis[0].anger,
      fill: '#F14239',
      },
    {
      name: 'Disgust',
      value:insights_data?.emotion_analysis[0].disgust,

      fill: '#8862D3',
      },
  ];

  const renderScreen = {
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          data={emotionAnalysis}
          maxWidth={'70%'}
          type={'%'}
          title={'Emotional_Analysis'}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
          drillThroughType={'emotion'}
          summary={
            resetFlag === true && filteredData
              ? filteredData?.emotion_summary
              : insights_data?.emotion_summary
          }
        />
      ) : (
        <BarGraph
          data={emotionAnalysis}
          maxWidth={'70%'}
          type={'%'}
          barHeight={'32px'}
          barHeightHover={'40px'}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
          drillThroughType={'emotion'}
          emojiList={{
            neutral: emoji_neutral,
            surprise: emoji_surprise,
            joy: emoji_joy,
            fear: emoji_fear,
            sadness: emoji_sadness,
            anger: emoji_anger,
            disgust: emoji_disgust,
            length: 2,
          }}
          title={'Emotional_Analysis'}
          summary={insights_data?.emotion_summary
          }
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        data={emotionAnalysis}
        width={500}
        type='percentage'
        title={'Emotional_Analysis'}
        summary={insights_data?.emotion_summary
        }
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'emotion'}
      />
    ),
    'Donut Chart': (
      <DonutChart
        data={emotionAnalysis}
        type='percentage'
        title={'Emotional_Analysis'}
        summary={insights_data?.emotion_summary
        }
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'emotion'}
      />
    ),
    'Funnel Chart': (
      <FunnelGraph
        data={emotionAnalysis}
        maxWidth={'80%'}
        type={'%'}
        title={'Emotional_Analysis'}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'emotion'}
        summary={insights_data?.emotion_summary
        }
      />
    ),
  };
    return (

        <Wrapper>
            <WordCloudAnalysis
                infoText={'A word cloud based on user sentiments or emotions, generated from keywords, hashtags, mentions, or emojis. The cloud can be represented using unigram, bigram, or trigram phrases to highlight key topics and trends.'
                }
                showSwitchTab={false}
                insightsData={ insights_data }
                hideDropdown={hideDropdown}
                startDate={startDateParsed}
                endDate={endDateParsed}
                formatValue={formatValue}
                channel={channel}
                showKeyWordDropDown={false}
            />

            <EmotionAnalysisWrapper>
                <GraphHOC
                    formatValue={formatValue}
                    title={'Emotion Analysis'}
                    options={options}
                    renderScreen={renderScreen}
                    graphWidth={'100%'}
                    margin={'20px 0px 20px 50px'}
                    startDate={startDateParsed}
                    endDate={endDateParsed}
                    option={filterOption}
                    hideDropdown={hideDropdown}
                    infoText={
                        channel == 'youtube' ?
                            'Percentage distribution of seven core emotions detected in viewer comments.'
                            :
                            channel === 'instagram'
                                ? 'The percentage distribution of seven unique user emotions expressed in comments.'
                                : channel === 'facebook'
                                    ? 'The percentage distribution of seven unique user emotions expressed in posts.'
                                    : 'The percentage distribution of seven unique user emotions expressed in posts.'
                    }
                />
            </EmotionAnalysisWrapper>

        </Wrapper>
    );
};


export default InsightsTab;